"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const Bookmark = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M4 2.997C4 2.447 4.445 2 5 2h14c.552 0 1 .445 1 .997v18.388c0 .55-.386.775-.871.497L12 17.796l-7.129 4.086c-.48.276-.871.055-.871-.497V2.997z", children: " " })
] });
var Bookmark_default = Bookmark;
export {
  Bookmark_default as default
};
